module.exports = __webpack_public_path__ + "img/logo-w.94cc4802.svg";